import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { update } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';

const RefiSnooze = ( { orgId, uid, close, l } ) => {
    const [ method, setMethod ] = useState( 'Date' );
    const [ startDate, setStartDate ] = useState( l.refiDateAlert || '' );
    const [ rate, setRate ] = useState( l.refiRateAlert || '' );
    const [ savings, setSavings ] = useState( l.refiSavingsAlert || '' );
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );
    const snoozeTypes = [
        'Date',
        'Rate',
        'Savings'
    ]
    const create = async () => {
        setProcessing( true );
        const today = new Date();
        const obj = {
            refiSnoozeDate: today.toJSON()
        };

        switch ( method ) {
            case 'Date':
                obj.refiDateAlert = startDate;
                break;

            case 'Rate':
                obj.refiRateAlert = rate;
                break;

            case 'Savings':
                obj.refiSavingsAlert = savings;
                break;

            default:
                alert( 'Something went wrong - please try again' );
                setProcessing( false );
                return;
        }

        // console.log( obj );
        const updated = await update( orgId, l.details.aid, uid, 'loan', l.details.lid, obj );
        if ( updated.length ) {
            toast.success( `The refi tasks have been snoozed - nice work!`, { theme: 'dark' } );
        }
        setProcessing( false );
        close();
    }

    const handleSavingsChange = ( e ) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setSavings( value );
    };
    
    const handleRateChange = ( e ) => {
        const value = e.target.value.replace(/[^0-9.]/g, '').replace(/^(\d*\.\d{4}).*$/, '$1');
        setRate( value );
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        switch ( method ) {
            case 'Date':
                setReady( startDate !== '' );
                break;

            case 'Rate':
                setReady( rate !== '' );
                break;

            case 'Savings':
                setReady( savings !== '' );
                break;

            default:
                setReady( false );
        }
    }, [ method, startDate, rate, savings ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Snooze Future Refi Alerts Until...</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Snooze Type</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={method} onChange={ ( e ) => setMethod( e.target.value ) }>
                                            {
                                                snoozeTypes.map( ( st, idx ) => <option key={idx} value={st}>{st}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                {
                                    ( method === 'Date' ) ? (
                                        <Form.Group>
                                            <Form.Label>Date to Begin Watching Again</Form.Label>
                                            <InputGroup style={{ width: '150px' }}>
                                                <Form.Control className='tf-modal-text-input' type="date" placeholder="Select a date" value={startDate} onChange={ ( e ) => setStartDate( e.target.value ) } />
                                            </InputGroup>
                                        </Form.Group>
                                    ) : (
                                        null
                                    )
                                }
                                {
                                    ( method === 'Rate' ) ? (
                                        <Form.Group>
                                            <Form.Label>Rate to Begin Alerting Again</Form.Label>
                                            <InputGroup style={{ width: '150px' }}>
                                                <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a rate" value={rate} onChange={handleRateChange} />
                                                <InputGroup.Text>%</InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    ) : (
                                        null
                                    )
                                }
                                {
                                    ( method === 'Savings' ) ? (
                                        <Form.Group>
                                            <Form.Label>Minimum Monthly Savings to Begin Alerting Again</Form.Label>
                                            <InputGroup style={{ width: '150px' }}>
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter an amount" value={savings} onChange={handleSavingsChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    ) : (
                                        null
                                    )
                                }
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Snooze</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    uid: state.user.email,
    pReason: state.user.meta.gift.picklist.reason
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( RefiSnooze );